<template>
    <div class="container-fluid">
        <Breadcrumb title="Add Email List" v-bind:button-show="false" v-show="!id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit Email List #' + id" v-bind:button-show="false" v-show="id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card" v-if="id">
                    <div class="card-body">
                        <div class="form-group mb-0">
                            <button v-show="emailList.job !== null"
                                    class="btn btn-success btn-rounded mr-2 mb-2"
                                    disabled>
                                                  <span class="spinner-border spinner-border-sm"
                                                        role="status"
                                                        aria-hidden="true">
                                                  </span>
                                Loading... {{this.emailList.completion || 0}} %
                            </button>
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                    v-show="emailList.job  === null" @click="uploadCardView = true">
                                <i class="fa fa-plus-circle"></i>
                                Add emails to list
                            </button>
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                    @click="getUploadFailures" :disabled="emailList.failedEmailsUrl === null">
                                <i class="fas fa-download"></i>
                                Get Upload Failures
                            </button>
                            <button type="button" class="btn btn-warning btn-rounded mr-2 mb-2"
                                    @click="cloneCardView = true">
                                <i class="fa fa-copy"></i>
                                Clone Email List
                            </button>
                        </div>
                    </div>
                </div>
                <transition name="bounce">
                    <div class="card" v-if="id" v-show="cloneCardView" :key="$route.fullPath">
                        <div class="card-body">
                            <button type="button" class="close" aria-label="Close" @click="cloneCardView = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <EmailListForm :id="id" :type="'clone'"></EmailListForm>
                        </div>
                    </div>
                </transition>
                <transition>
                    <div class="card" v-show="uploadCardView" :key="$route.fullPath">
                        <div class="card-body">
                            <button type="button" class="close" aria-label="Close" @click="uploadCardView = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div>
                                <div class="form-group">
                                    <h4>Upload csv file with new emails.</h4>
                                    <small class="form-text text-muted mt-0">
                                        <br/>
                                        Header is required. Field separator is comma. <br/>
                                        Required fields: email. <br/>
                                        Optional fields: name, surname, birthYear, city, geo.<br/>
                                        Example:<br/>
                                        email, name, surname, birthYear, city, geo<br/>
                                        abc@gmail.com, Ivan, Semenov, 1995, Moscow, RU<br/>
                                        qrz@ymail.com, John, Dow, 1989, London, UK<br/>
                                    </small>
                                </div>
                                <div class="form-group text-left">
                                    <input type="file" id="emailsList" accept="text/csv" class="w-100"/>
                                </div>
                                <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                        @click="addEmails()">
                                    <i v-if="!uploading" class="fas fa-upload"></i>
                                    <i v-if="uploading" class="spinner-grow spinner-grow-sm" role="status"></i>
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </transition>
                <div class="card">
                    <div class="card-body">
                        <EmailListForm
                                @hidePreloader="hidePreloader"
                                @setEmailList="setEmailList"
                                :id="id"
                                :type="'edit'"
                                :key="$route.fullPath">
                        </EmailListForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumb from '../components/Breadcrumb';
    import Preloader from '../components/Preloader';
    import EmailListForm from './forms/EmailListForm';
    import Swal from 'sweetalert2';
    import EmailService from '../services/EmailService';
    import EmailListService from '../services/EmailListService';
    import config from '../config';
    import {mapGetters} from 'vuex';

    export default {
        name: 'EmailList',
        props: ['id'],
        components: {Breadcrumb, EmailListForm, Preloader},
        data() {
            return {
                loading: true,
                cloneCardView: false,
                emailList: {
                    id: null,
                    name: null,
                    category: null,
                    completion: null,
                    failedEmailsUrl: null,
                    job: null,
                    users: null,
                },
                uploadCardView: false,
                uploading: false
            }
        },
        mounted() {
            if (this.id) {
                this.emailListUploadProgress();
            } else {
                this.loading = false;
            }
        },
        methods: {
            setEmailList(emailList) {
                this.emailList = emailList;
            },
            hidePreloader(value) {
                this.loading = !value
            },
            addEmails() {
                this.uploading = true;
                let emails = document.getElementById('emailsList').files[0];
                let formData = new FormData();

                formData.append('emailListId', this.id);
                formData.append('emails', emails);

                return EmailService.addEmailsToList(formData)
                    .then(response => {
                        if (response.data.error) {
                            let message = null;
                            if (response.data.error.message !== undefined) {
                                message = response.data.error.message;
                            } else if (response.data.error.emails !== undefined) {
                                message = 'File: ' + response.data.error.emails;
                            } else if (response.data.error.emailListId !== undefined) {
                                message = 'Email List: ' + response.data.error.emailListId;
                            }
                            Swal({
                                type: 'warning',
                                text: message
                            });

                            this.uploading = false;
                            return false;
                        }

                        Swal(
                            'Added successfully!',
                            `We will notify you, when moderation process will be done.`,
                            'success'
                        );
                        this.emailList.job = 1;
                        this.uploading = false;
                    })
                    .catch(() => {
                        Swal.showValidationMessage(
                            `Sorry, some error occurred.`
                        );
                        this.uploading = false;
                    });
            },
            getUploadFailures() {
                EmailListService.getFailedEmailsList(this.id).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.id + '_failures');
                    document.body.appendChild(link);
                    link.click();
                })
            },
            emailListUploadProgress() {
                if (!this.mercureListen.hasOwnProperty(config.uploadEmailListProgressStatus)) {
                    let url = new URL(config.mercureHubUrl);
                    url.searchParams.append('topic', config.uploadEmailListProgressStatus);
                    let eventSource = new EventSource(url);
                    this.$store.commit('setListening', {[config.uploadEmailListProgressStatus]: eventSource});
                }
                this.mercureListen[config.uploadEmailListProgressStatus].onmessage = event => {
                    let data = JSON.parse(event.data);
                    if (data.emailListId !== undefined) {
                        this.emailList.completion = parseInt(data.completion);
                        this.emailList.job = parseInt(data.jobId);
                        this.emailList.job = isNaN(this.emailList.job) ? null : this.emailList.job;
                    }
                }
            }
        },
        computed: {
            ...mapGetters({mercureListen: 'listen'})
        },
        watch: {
            '$route.params.id'() {
                this.cloneCardView = false;
                this.loading = true;
            }
        }
    }
</script>

<style scoped>
    .bounce-enter-active {
        animation: bounce-in .8s;
    }

    .bounce-leave-active {
        animation: bounce-in .5s reverse;
    }

    @keyframes bounce-in {
        0% {
            transform: scale(0.5);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }
</style>
